import {Component, OnInit, signal} from '@angular/core';
import {ExtraCostType} from '../classes/extracosttype.class';
import {ExtraCostsService} from '../services/extraCosts/extra-costs.service';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {VvrIconComponent} from "../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
    selector: 'app-extra-costs-overview',
    templateUrl: './extra-costs-overview.component.html',
    styleUrls: ['./extra-costs-overview.component.scss'],
    imports: [
        VvrIconComponent,
        RouterLink,
        MatTooltip
    ]
})
export class ExtraCostsOverviewComponent implements OnInit {

    public readonly extraCostTypes = signal<ExtraCostType[]>([]);

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private extraCostsService: ExtraCostsService
    ) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.extraCostsService.getList().then(extraCostTypes => {
                this.extraCostTypes.set(extraCostTypes);
            });
        });
    }

    openDecoration(extraCostType) {
        this.router.navigate([`extra-costs`, extraCostType.id]);
    }

}
